<i18n>
  {
    "ru": {
      "account": "Личный кабинет",
      "logout": "Выход",
      "partners": "Партнёры",
      "news": "Новости",
      "directory": "Справочная",
      "services": "Услуги",
      "bulletin_board": "Объявления",
      "another": "Другое"
    },
    "uk": {
      "account": "Особистий кабінет",
      "logout": "Вихід",
      "account": "Особистий кабінет",
      "logout": "Вихід",
      "partners": "Партнери",
      "news": "Новини",
      "directory": "Довідкова",
      "services": "Послуги",
      "bulletin_board": "Оголошення",
      "another": "Інше"
    }
  }
</i18n>
<template>
  <div class="as-mobile-nav mobile-vis">
    <div class="header">
      <span>{{ $t("account") }}</span>
    </div>
    <ul class="nav">
      <!--<li class="nav-item">
        <a class="nav-link show-auth" data-type="#tab-auth" href="#">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFdSURBVDhP1ZMxLMVAGMdLhNC7EonJYDCSSCwGklp6d2ESkbCQiNVglngTCZuFsXd9pjdKLCKR2KxIEAxvYhThbcL/qy9dqvps/JIvvf///nfX79J6/42PlsDYQSo2fo8wbkIoeyOVe09Lu2sRxeM83Rx+lAwLbV8D5Vb7wpqgojF5vrZDHCsHb3Ikld1mmQF/B5sdsixHavuE1kKWGb6OJ9HmI8tyEL7yTTLPMiPQdgGHXLIsRyi3gc0uek01YMujMXmYW2erCcxuBxad4D7q6b183U0ddezN1do5VU63ro4K7c5x4Q3UGVeDvC6VjHDsZ2SUjOH1X7DI4fmGDRZl5JbSjZSN4T9ThuMFhKdtCD7QN0MSraxg8S0VWl0mT0Z2DQfcU5b0twgVz2LxnVeptLKVB3OUEcbOsJMHp27hV9hjWQja3Ed2k2WenqmDgc5p28+yEMpQluWfxPM+AanzfME1+Z/0AAAAAElFTkSuQmCC">
            Личный кабинет
        </a>
      </li>-->
      <li class="nav-item" v-if="$store.state.session.isAuth">
        <Toolbar />
      </li>
      <li class="nav-item" v-if="!$store.state.session.isAuth">
        <ModalReg />
      </li>
      <li class="nav-item" v-if="!$store.state.session.isAuth">
        <ModalAuth />
      </li>
      <li class="nav-item" v-if="$store.state.session.isAuth">
        <router-link class="nav-link" :to="'/' + this.locale + '/account'">{{
          $t("account")
        }}</router-link>
      </li>
      <li class="nav-item" v-if="$store.state.session.isAuth">
        <a class="nav-link" href="#" @click.prevent="signOut">{{
          $t("logout")
        }}</a>
      </li>
      <!--<li class="nav-item">
        <a class="nav-link" href="#">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAE7SURBVDhPY4ABXreFrTxuC7/yui/8jxe7LXzF47EgEKoNAgRdFsqBJLndFobzuy0wxoeB6jp43Bfcg2qFAG7PebogAwRdZvJDhXACXvf53jzuCz9AuRBA2ID/jAyhq9hALF7XBZ4kG8DtvtAF6PcrAl5L5IEGMYPCCyoFAYQMADkbJA/U+BwUDlBhBEA3ABhI6TxuC97BsfuCz2ADgBjI/sLrusgXrBEG0A3gdV/QDtOAFbst+AMMhwywZhAg2QD3BS+BrjAHawYBdAMggbZgFRI+jGTAdX7nuUpgjTBAfCAuOMDnNlsIFqVwQMgALo+FhkD5mQweE9l5nRcKA/2/EyoFAYQMQAZkpkQEwGoAyF/ARPID6MepwHgvJ4C3AtPCaahWBAAa4APMzluAhuwmgFfxui9Wh+hiYAAACuHploN9ZPQAAAAASUVORK5CYII=">
            Выход
        </a>
      </li>-->
      <!--<li class="nav-item">
        <a class="nav-link" href="#">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFpSURBVDhPzVG/L0RBEF4kxLvdu0QQEoWOEoVEo5G3+8KF6hr/BYXQOJFIlOQqhN29dwpXXKIQBZGIQiR6nZBLFAoVgoZvn8lzF+dHeV8y2cw3M9/M7LA6QjbbmJR2miub49Kueb4eoAgDNyWU2RTKrnLfjBL9he70hofgqZD2HsWhkOYI/pvwzQyKC+CeENuDlWAviC9T6Se4ys9xZW55eredKIaOk0h8hZWFCvuIBm9HHO8FdpAoCEi7D+UVcmMkpRluDcIecmNA4MxNR2604yFEFsn9E2h2jIkXyI3GWoLIJWPvDUT9CB5sd2CC50Sgx4hizBvXXVyaB0wxT1RtZIpNyDtA3vm3ZkLpieiHlZ0lqhrBegviuIS5SyndS2w13L2x2yPenOtGND5zq819HGLXXOp+omsjpcIhJJfRreS6uitgqqtIoOLMvyIuUvYEO99EYpliM4X/h4Sf78QqF7CdynXqDYx9APtVf4h5azjJAAAAAElFTkSuQmCC">
            Избранное
        </a>
      </li>-->
      <!--<li class="nav-item">
        <a class="nav-link" href="#">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVDhPjVM7S1xRED4qQtx7zl1foIKgViGFoNgp+Ijec9YHNsFCUqVKkTRCSHzhVtoIIppGfJxz7q4K1iKIhSAEAoL/IK1FqtikCtl8c53NxrDKfjDcme/OfDNzZ1c8BWnc21TG93JYIbLZ6rSxnU3Te0oafw6R5eDlUUtqwrZyRnkoHfdL7bJS+yMqQnFeaf8dz2+wDfhr4B29S5lcG5eVEGg3Eho3y6GgjhC8Q8E1U0L07dSC+1Q/ke9gpgSp7atQ29ccCjFkn6Ui26NM7jkzCSC4VZfJtXNYApRjGp9DoUZ9k9LuFnbBlGgY20ljlUuILDJ1D1LEnusQWJFj/gXTEPWnsHkOk6sExg5D9FiIQhXTSeJ8MH7QTV8fHVaZLiPg81QYmPidjOwA04nyIbvJKmLmpObeLwnQt4C/Qn6odxshtk2+IDUaSWbimcSM24ctUKeigJw6bKbuyPtQzIN/lUxB91XGFx6Ydp9J/O8EOB+4m/9yfiljJ5FWqAq1e4+uX2BfVeTmyq6Aq8DfJCFMcxbqOCL+SVAiRB+erFKg25Iy7jc6/qyoWxEycoP0c0X3H//si7Hjj+ko7uK0x4FC/HHcxSP2htMYQvwB0qnHovFP3moAAAAASUVORK5CYII=">
            Сравнить
        </a>
      </li>-->
      <li class="info">
        <span>{{ $t("another") }}</span>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="'/' + this.locale + '/partners'">{{
          $t("partners")
        }}</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="'/' + this.locale + '/news'">{{
          $t("news")
        }}</router-link>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">{{ $t("directory") }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import ModalAuth from "@/components/modals/Auth.vue";
import ModalReg from "@/components/modals/Reg.vue";
import Toolbar from "@/components/cockpit/index.vue";

export default {
  data() {
    return {
      locale: this.$route.params.locale
    };
  },
  methods: {
    signOut() {
      this.$auth.signOut(this.$store);
    }
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  },
  components: {
    ModalAuth,
    ModalReg,
    Toolbar
  }
};
</script>
